import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { Box, Portal } from "@mui/material";
import { ProductCategoriesDropdown } from "features/analytics";
import { useSelectedProject } from "Hooks";
import { useProducts } from "Hooks/useProducts";
import { ProductSinglePage } from "features/analytics";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PageActionPreSlot } from "consts";
import AnalyticsCard from "features/analytics/components/AnalyticsCard";

function ProductCategoryReportPage() {
  const history = useHistory();
  const { products } = useProducts();
  const { selectedClient, selectedProject } = useSelectedProject();
  const [selectedProductCategory, setSelectedProductCategory] = useState<
    string | undefined
  >();

  const { state } = useLocation<{
    selectedProductCategory: string;
  }>();

  useEffect(() => {
    if (state) {
      setSelectedProductCategory(state.selectedProductCategory);
    }
  }, [state]);

  const onClick = (productName: string) => {
    history.push(
      `/clients/${selectedClient?.id}/projects/${selectedProject?.id}/analyse/standard-reports/product-deep-dive`,
      {
        selectedProductId: products.find((p) => p.name === productName)?.id,
      }
    );
  };

  return (
    <>
      <Portal container={() => document.getElementById(PageActionPreSlot)}>
        <ProductCategoriesDropdown
          sx={{ minWidth: 230 }}
          fullWidth
          size="small"
          variant="outlined"
          label="Select Product Category"
          value={selectedProductCategory}
          onChange={(n) => {
            setSelectedProductCategory(n);
          }}
        />
      </Portal>
      <ProductSinglePage
        selectedProductCategory={selectedProductCategory}
        setSelectedProductCategory={setSelectedProductCategory}
        dimension={ApiDimension.DIMENSION_PRODUCT_CATEGORY}
      />
      {selectedProductCategory && (
        <Box my={3} sx={{ height: 436 }}>
          <AnalyticsCard
            onClick={{
              [ApiDimension.DIMENSION_PRODUCT_NAME]: onClick,
            }}
            chart={{
              name: ``,
              dimension: [ApiDimension.DIMENSION_PRODUCT_NAME],
              template: ApiChartTemplate.TABLE,
              type: ApiChartType.TABLE,
              attributes: [
                {
                  key: ApiDimension.DIMENSION_PRODUCT_CATEGORY,
                  value: selectedProductCategory,
                },
              ],
              comparison: true,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [
                    ApiMetric.METRIC_PAGEVIEWS_COUNT,
                    ApiMetric.METRIC_PRODUCT_CLICK_THROUGH_COUNT,
                    ApiMetric.METRIC_PRODUCT_CLICK_THROUGH_RATE,
                    ApiMetric.METRIC_PRODUCT_REVENUE,
                    ApiMetric.METRIC_PRODUCT_IMPRESSIONS_COUNT,
                    ApiMetric.METRIC_PRODUCT_IMPRESSION_RATE,
                    ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_COUNT,
                    ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_RATE,
                    ApiMetric.METRIC_SALES_COUNT,
                    ApiMetric.METRIC_SALES_COMPLETION_RATE,
                    ApiMetric.METRIC_SALES_REVENUE,
                    ApiMetric.METRIC_VISIT_TO_PURCHASE_RATE,
                    ApiMetric.METRIC_PRODUCT_GATEWAY_LTV,
                  ],
                },
              ],
              displayOptions: {
                noFilters: true,
                noTitle: true,
              },
            }}
          />
        </Box>
      )}
    </>
  );
}

export default ProductCategoryReportPage;
